import { Appointment, FIELD_TYPE, TAptFieldOption } from "@elixir/types";
import useGetQueueConfig from "../../../../apis/tryst/get-queue-config";
import { useMemo } from "react";
import TextFieldAction from "./text-field-action";
import PersonSelectDropdown from "./person-select-dropdown";
import OptionsSelectDropdown from "./options-select-dropdown";

const AptFieldAction = ({
  apt,
  fieldId,
}: {
  apt: Appointment;
  fieldId: string;
}) => {
  const { data: queueConfig } = useGetQueueConfig();
  const { apt_fields } = queueConfig?.data || {};
  const fieldItem = apt_fields?.find((field) => field.field_id === fieldId);
  const { fieldMeta } = fieldItem || {};
  const { type } = fieldMeta || {};

  const transformedOptions = useMemo(() => {
    if (!fieldItem?.options) return [];
    const selectedOptions =
      apt.apt_fields?.find((field) => field.field_id === fieldId)?.values ?? [];
    let transformedOptions: TAptFieldOption[] = fieldItem?.options;

    transformedOptions = transformedOptions.map((option) => ({
      ...option,
      isSelected:
        selectedOptions.filter((selectedOption) => selectedOption === option.id)
          .length > 0,
    }));
    return transformedOptions;
  }, [apt.apt_fields, fieldId, fieldItem]);

  const selectedOptionsText = useMemo(() => {
    if (type !== FIELD_TYPE.OPTION) return "";
    const selected = transformedOptions.filter((option) => option.isSelected);
    if (selected.length === 0) return "";
    return selected.map((option) => option.value).join(", ");
  }, [transformedOptions, type]);

  if (!fieldItem) return null;

  fieldItem.options = transformedOptions;

  const isEditable = !!fieldItem?.is_editable;

  return type === FIELD_TYPE.TEXT ? (
    <TextFieldAction apt={apt} fieldItem={fieldItem} isDisabled={!isEditable} />
  ) : type === FIELD_TYPE.OPTION ? (
    isEditable ? (
      <div className="dr-flex-1 dr-max-w-165">
        <OptionsSelectDropdown apt={apt} fieldItem={fieldItem} isDisabled={false} />
      </div>
    ) : (
      <div className="dr-flex-1 dr-max-w-165">
        <div className="BodyRegular dr-text-darwin-touch-neutral-600 dr-line-clamp-1 dr-rounded-4 dr-border-1 dr-border-solid dr-border-darwin-touch-neutral-100 dr-py-7 dr-px-8">
          {selectedOptionsText || (fieldItem.title ?? "").replace(/_/g, " ")}
        </div>
      </div>
    )
  ) : type === FIELD_TYPE.PERSON ? (
    <PersonSelectDropdown apt={apt} fieldId={fieldId} isDisabled={!isEditable} />
  ) : null;
};

export default AptFieldAction;
